<div class="withdraw-close" [formGroup]="parent">
  <h2 class="ds-heading-2">{{ 'ACCOUNT.withdrawalV2.account.heading' | translate }}</h2>

  <app-ds-radio-option
    [value]="option.value"
    [selected]="keepAccountControl.value"
    (clicked)="onKeepAccountChange($event)"
    *ngFor="let option of selectOptions"
    variant="box"
  >
    <ng-container ds-radio-title>{{ option?.title | translate }}</ng-container>
    <ng-container ds-radio-desc>{{ option?.desc | translate }}</ng-container>
  </app-ds-radio-option>
</div>
<div class="withdraw-buttons" [class.mobile-buttons]="isMobileApp" [ngStyle]="{ display: isMobileApp ? 'block' : 'flex' }">
  <app-ds-button [width]="isMobileApp ? 'full' : 'auto'" (clicked)="onContinue()">{{
    'ACCOUNT.withdrawalV2.buttons.next' | translate
  }}</app-ds-button>
  <app-ds-button [width]="isMobileApp ? 'full' : 'auto'" variant="outline" (clicked)="onBack()">{{
    'ACCOUNT.withdrawalV2.buttons.previous' | translate
  }}</app-ds-button>
</div>
